module.exports = "/dist/sounds/new_customer.mp3";